export default function useNotification(showSwal) {
    const showNotification = (type, title, message) => {
      showSwal.methods.showSwal({
        type: type,
        title: title,
        message: message,
        width: 400,
      });
    };
  
    return { showNotification };
  }